import * as React from 'react';
import { ProtectedRoute, monitorRouterMatch } from '../../common/components';
import VisualBlocksPage from '../screens/VisualBlocksPage';
import { STORE_PROJECT_VISUAL_BLOCKS } from '../constants';

export const VisualBlocksPagesNavigation = {
    ProjectVisualBlocksPage: '/projects/:id/visualBlocks/:packageId/:pageNumber'
};

export default () => {
    return (
        <ProtectedRoute
            component={monitorRouterMatch(STORE_PROJECT_VISUAL_BLOCKS, (s, m) =>
                s[STORE_PROJECT_VISUAL_BLOCKS].setMatch(m!.params)
            )(VisualBlocksPage)}
            path={VisualBlocksPagesNavigation.ProjectVisualBlocksPage}
        />
    );
};
